const Fallback: React.FC<{}> = () => {
  return (
    <div>
      <h2 className="text-sm uppercase text-very_light_pink">
        Es ist ein Fehler aufgetreten.
      </h2>
    </div>
  );
};

export default Fallback;
